var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewind365Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-80bd8e38-f8a3-474c-ac5a-cfde4deac151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 385.98 55.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293{fill:#1f2c3c;}.uuid-f4d4a0be-d897-4934-81c2-33e8fa0b49f6{fill:url(#uuid-1fcb6114-1386-4661-845a-5f94312e9303);}.uuid-3d2fe59e-10ae-4980-9553-386386a58eb9{fill:url(#uuid-7c99f69a-44a8-4dd7-b7fa-3676ce89ef6d);}.uuid-d3084c68-6995-45a1-8618-f4d00151f86f{fill:url(#uuid-660dd91e-fa14-4082-8786-cd10a60b3d89);}.uuid-27cdcae4-b4aa-4e79-b318-07cb66487ba6{fill:url(#uuid-9d26f01b-8aeb-4154-bbae-0609bdd6c536);}.uuid-b42bf5c2-c9c0-4f5d-9ec9-4d15acbad26f{fill:url(#uuid-54b4c21f-ba90-4720-9e0e-969d5bf2c3ae);}.uuid-c1cc686d-a566-4c13-aca7-9c87a7148b2a{fill:url(#uuid-70ae531e-d283-440f-8aa7-d93851f0a692);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7c99f69a-44a8-4dd7-b7fa-3676ce89ef6d",
    x1: 256.1,
    y1: 57.76,
    x2: 300.53,
    y2: 13.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#140a28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#131030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#12193c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#10274d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0d3864"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#094e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0568a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0085c6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0089cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#028fcc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0baad0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fb5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-70ae531e-d283-440f-8aa7-d93851f0a692",
    x1: 238.72,
    y1: 41.91,
    x2: 283.61,
    y2: -2.98,
    xlinkHref: "#uuid-7c99f69a-44a8-4dd7-b7fa-3676ce89ef6d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-54b4c21f-ba90-4720-9e0e-969d5bf2c3ae",
    x1: 255.51,
    y1: 57.87,
    x2: 300.17,
    y2: 13.21,
    xlinkHref: "#uuid-7c99f69a-44a8-4dd7-b7fa-3676ce89ef6d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-660dd91e-fa14-4082-8786-cd10a60b3d89",
    x1: 297.32,
    y1: 56.41,
    x2: 350.06,
    y2: 3.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#140d2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#121a3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0e2f57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#094c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0371ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0089cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#069cce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fb5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1fcb6114-1386-4661-845a-5f94312e9303",
    x1: 326.32,
    y1: 47.2,
    x2: 378.4,
    y2: -4.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150927"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#0b4271"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0089cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#018ecb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#079ece"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fb5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-9d26f01b-8aeb-4154-bbae-0609bdd6c536",
    x1: 343.99,
    y1: 56.93,
    x2: 392.88,
    y2: 8.04,
    xlinkHref: "#uuid-1fcb6114-1386-4661-845a-5f94312e9303"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-5072609d-d78c-4cd9-a276-cd70cc171830"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M59,23.98l.21,.07c2.19-3.01,5.74-5.33,11.07-5.33v7.04l-.68,.48c-.75-.34-1.98-.61-3.83-.61-3.21,0-5.94,1.91-7.52,3.76l-4.03,23.57h-6.97l4.03-23.16c.21-1.3,.41-3.01,.41-4.03,0-1.78-.34-3.21-1.3-4.51l7.11-2.53c1.02,1.16,1.5,3.62,1.5,5.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M76.46,41.48c0,3.83,1.3,6.7,5.47,6.7,3.01,0,6.63-2.6,9.43-5.33l3.48,3.96c-4.03,3.83-9.16,7.17-15.17,7.17-7.24,0-10.11-4.51-10.11-10.8,0-11.82,7.31-24.46,18.93-24.46,5.19,0,8.68,2.39,8.68,6.83,0,7.86-6.49,11.41-14.21,11.41-1.91,0-4.44-.27-5.88-.75-.41,1.23-.62,2.94-.62,5.26Zm7.52-9.16c3.21,0,6.29-1.43,6.29-5.06,0-2.19-1.91-3.21-3.96-3.21-3.89,0-6.56,3.69-7.99,7.52,1.5,.48,3.76,.75,5.67,.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M115.81,52.96h-7.52l-8.61-32.05,7.11-2.19,3.01,12.3c.82,3.28,2.25,10.04,3.07,14.62h.34l7.17-23.78,6.08-1.84,3.55,10.93c1.09,3.55,2.94,9.91,4.17,14.69h.34l6.01-26.44,7.24,.75-10.04,33h-7.52l-3.42-10.32c-1.09-3.42-2.46-8.13-3.42-12.09h-.34l-7.24,22.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M160.57,3.96l-1.37,7.72-3.42,1.23-5.12-5.67v-1.78l8.81-2.67,1.09,1.16Zm-7.99,48.99V20.91l7.38-2.19V52.96h-7.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M176.1,23.16l.21,.14c3.35-2.53,7.65-4.58,12.57-4.58,6.7,0,8.13,5.47,8.13,11.07v23.16h-7.38v-20.84c0-4.44-1.23-6.83-5.33-6.83-3.01,0-5.81,1.23-8.06,3.01v24.67h-7.38V29.59c0-4.03-.68-6.01-1.91-7.93l7.04-2.94c.96,.96,1.84,2.94,2.12,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    d: "M232.89,43.12c0,4.1,.82,5.94,2.25,7.65l-6.83,3.21c-1.3-.96-2.39-2.94-2.73-4.37l-.27-.14c-3.55,2.94-7.45,4.51-11.48,4.51-6.56,0-10.18-7.31-10.18-14.9,0-11.62,5.67-20.22,17.08-20.22,1.64,0,3.48,.27,4.78,.68V2.19l7.38-2.19V43.12Zm-12.5-18.59c-5.33,0-9.22,3.89-9.22,12.3,0,6.83,2.53,10.59,7.17,10.59,2.46,0,4.99-1.03,7.17-3.01V25.9c-.89-.61-3.01-1.37-5.12-1.37Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 36.62,
    cy: 21.87,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 36.62,
    cy: 31.19,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 36.62,
    cy: 40.5,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 36.62,
    cy: 49.82,
    r: 3.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 25.5,
    cy: 21.87,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 25.5,
    cy: 31.19,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 25.5,
    cy: 40.5,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 25.5,
    cy: 49.82,
    r: 3.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 14.38,
    cy: 31.19,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 14.38,
    cy: 40.5,
    r: 3.26
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 3.26,
    cy: 31.19,
    r: 3.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-4e8db682-86fe-4bc8-ae97-cf24eed6a293",
    cx: 3.26,
    cy: 40.5,
    r: 3.26
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-3d2fe59e-10ae-4980-9553-386386a58eb9",
    d: "M295.95,33.03c-1.46-1.95-3.43-3.33-6.03-4.21l-.55-.19v-1.48l.48-.22c2.14-.96,3.86-2.32,5.11-4.05,1.22-1.69,1.85-3.79,1.85-6.24s-.69-4.59-2.04-6.5c-1.37-1.95-3.29-3.49-5.69-4.59-2.44-1.11-5.26-1.67-8.39-1.67h-.37v7.12c1.89,.17,3.49,.72,4.82,1.66,1.7,1.2,2.56,2.98,2.56,5.3s-.82,4.19-2.43,5.45c-1.34,1.06-3,1.67-4.93,1.82v.7c0,2.86,1.76,5.45,4.44,6.45,.39,.14,.75,.31,1.1,.48,1.98,1.02,2.99,3.06,2.99,6.06,0,2.59-.88,4.58-2.61,5.9-1.46,1.11-3.46,1.74-5.94,1.88v7.1h.37c3.53,0,6.65-.59,9.28-1.75,2.6-1.16,4.63-2.78,6.04-4.83,1.41-2.03,2.12-4.36,2.12-6.92,0-2.93-.73-5.38-2.17-7.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-c1cc686d-a566-4c13-aca7-9c87a7148b2a",
    d: "M272.56,4.85c-.64,.2-1.28,.44-1.93,.72-.89,.4-1.75,.87-2.53,1.41-1.31,.89-2.41,1.97-3.29,3.21-1.4,1.97-2.08,4.11-2.08,6.54v.72h3.42c2.26,0,4.47-1.04,5.67-2.96,.21-.34,.46-.67,.75-.97V4.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-b42bf5c2-c9c0-4f5d-9ec9-4d15acbad26f",
    d: "M269.23,51.99c1.03,.47,2.13,.85,3.33,1.14v-8.03c-1.7-1.18-2.65-2.97-2.82-5.35h-8.4v.2c0,2.65,.67,5.04,1.99,7.12,1.35,2.11,3.28,3.72,5.91,4.93Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "uuid-d3084c68-6995-45a1-8618-f4d00151f86f",
    d: "M341.41,17.05c-.11-2.91-.83-5.47-2.13-7.63-1.41-2.36-3.39-4.17-5.87-5.38-2.51-1.23-5.33-1.86-8.41-1.86h-1.02c-3.09,0-5.97,.74-8.58,2.19-2.59,1.46-4.67,3.49-6.2,6.03-1.52,2.54-2.29,5.4-2.29,8.49v19.79c0,3.28,.75,6.15,2.3,8.75,1.52,2.55,3.62,4.56,6.26,5.98,2.64,1.41,5.58,2.12,8.74,2.12h1.02c3.21,0,6.17-.68,8.8-2.03,2.59-1.33,4.67-3.25,6.17-5.72,1.49-2.47,2.25-5.39,2.25-8.67,0-2.89-.68-5.47-2.03-7.65-1.35-2.16-3.21-3.85-5.52-5.02-2.34-1.18-4.98-1.78-7.85-1.78-1.11,0-2.21,.13-3.29,.4v5.54c.33-.03,.68-.05,1.02-.05,2.48,0,4.58,.79,6.22,2.34,1.64,1.56,2.48,3.58,2.48,5.99v1.53c0,2.37-.86,4.38-2.55,5.96-1.69,1.57-3.76,2.37-6.15,2.37s-4.58-.79-6.25-2.34c-1.67-1.57-2.52-3.59-2.52-6V17.64c0-1.51,.44-2.94,1.3-4.25,.86-1.28,1.96-2.3,3.27-3.04,1.35-.75,2.73-1.13,4.12-1.13,2.42,0,4.43,.85,5.97,2.53,.5,.55,.93,1.14,1.26,1.78,1.19,2.23,3.62,3.51,6.14,3.51h3.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "uuid-f4d4a0be-d897-4934-81c2-33e8fa0b49f6",
    d: "M383.5,4h-31.25v7.23h24.54c3.71,0,6.71-3.01,6.71-6.72v-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-27cdcae4-b4aa-4e79-b318-07cb66487ba6",
    d: "M360.24,51.82c2.57,1.24,5.65,1.87,9.16,1.87,5.33,0,9.46-1.54,12.29-4.57,2.85-3.05,4.29-7.19,4.29-12.3,0-2.9-.54-5.57-1.6-7.94-1.04-2.33-2.66-4.22-4.81-5.62-2.15-1.4-4.91-2.11-8.19-2.11-2.2,0-4.24,.37-6.05,1.11-1.79,.73-3.2,1.69-4.2,2.87l-1.39,1.63v-1.31c0-3.71-3.01-6.71-6.71-6.71h-.78v13.24h8.43c.68-1.3,1.68-2.37,2.98-3.18,1.45-.9,3.21-1.36,5.24-1.36,2.81,0,5.03,.82,6.6,2.44,1.56,1.61,2.35,3.87,2.35,6.72s-.74,5.38-2.2,7.2c-1.5,1.87-3.77,2.81-6.75,2.81-2.46,0-4.48-.7-5.99-2.09-1.35-1.23-2.27-2.87-2.73-4.86h-8.23c.23,2.63,1.01,4.97,2.3,6.97,1.43,2.21,3.44,3.95,5.99,5.18Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewind365Logo);
export default __webpack_public_path__ + "static/media/rewind365-logo.bfa6428e4a3be8955ae945b75dd8cd9d.svg";
export { ForwardRef as ReactComponent };